import * as React from 'react'

export const SVG_Back = () => (
    <svg width="32" height="33" viewBox="0 0 32 33">
        <g fill="#4f5b68" fillRule="evenodd">
            <path
                id="back"
                d="M10.042 16.638c.005.24.111.478.318.64l10.21 8.033a.9.9 0 0 0 1.234-.123.833.833 0 0 0-.126-1.194l-9.546-7.51 9.506-7.478a.833.833 0 0 0 .127-1.194.901.901 0 0 0-1.234-.123l-10.21 8.032a.832.832 0 0 0-.28.917"
            />
        </g>
    </svg>
)
